import React from "react";
import { useNavigate } from "react-router-dom";
import { Card } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Clock } from "lucide-react";

export default function ComingSoon({ title, blurb, icon: Icon = Clock }) {
  const nav = useNavigate();
  return (
    <div className="p-8 lg:p-12 max-w-3xl" data-testid="coming-soon">
      <Card className="p-10 lg:p-14 text-center">
        <div className="w-14 h-14 mx-auto rounded-full bg-secondary flex items-center justify-center mb-6">
          <Icon className="h-7 w-7 text-primary" />
        </div>
        <p className="text-xs uppercase tracking-[0.25em] text-primary mb-3">Coming soon</p>
        <h1 className="font-serif text-3xl lg:text-4xl font-black tracking-tight">{title}</h1>
        {blurb && <p className="text-muted-foreground mt-4 max-w-md mx-auto leading-relaxed">{blurb}</p>}
        <Button onClick={() => nav("/dashboard")} className="mt-8 rounded-full" variant="outline">
          Back to dashboard
        </Button>
      </Card>
    </div>
  );
}
